/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
//import Footer from "../../components/CommonComponents/Footer";
import Header from "../../pages/Header";
import ScrollToTopWrapper from "../../components/CommonComponents/ScrollToTopWrapper";
import { ROUTE_PATH } from "../../constants/route";
import Analytics from "../../components/Analytics";
import FooterNew from "../../components/CommonComponents/FooterNew";
import { fetchShopifyAccountCheck } from "../../store/reducers/createProfile/apithunk";
import { actions } from "../../store/reducers/createProfile";

const PublicLayout = ({
  children,
  privateRoute = false,
  navigationPage = false,
}) => {
  const location = useLocation();
  const authentication = useSelector((state) => state.authentication);
  const createProfile = useSelector((state) => state.createProfile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      null;
    if (token) {
      if ([ROUTE_PATH.LOGIN, ROUTE_PATH.SIGNUP].includes(location?.pathname)) {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
      } else if ([ROUTE_PATH.DASHBOARD].includes(location?.pathname)) {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
      }
    } else if (privateRoute === true) {
      if (![ROUTE_PATH.LOGIN, ROUTE_PATH.SIGNUP].includes(location?.pathname)) {
        navigate(ROUTE_PATH.LOGIN);
      }
    }
  }, [authentication, privateRoute, location?.pathname]);

  useEffect(() => {
    const token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      null;
    
    const shopifyAccountCheck = createProfile?.shopifyAccountCheck; 
         // Only call API if token exists and no valid Shopify data
     if (token && (!shopifyAccountCheck?.message?.length > 0)) {
       dispatch(fetchShopifyAccountCheck());
     } else {
      if(!token){
        dispatch(actions.clearShopifyAccountCheck());
      } else {
        console.log("already has data")
      }
     }
  }, [authentication, dispatch]);
  
  // Get token from authentication
  const token =
    authentication?.auth?.data?.auth_token ||
    authentication?.auth?.data?.data?.auth_token ||
    authentication?.userData?.data?.auth_token ||
    null;
    
  // If privateRoute is true and no token, don't render children
  const shouldRenderChildren = !privateRoute || token;
  
  return navigationPage ? (
    shouldRenderChildren ? children : null
  ) : (
    <ScrollToTopWrapper>
      <Analytics />
      <Header />
      <Box sx={{ marginTop: "74px" }}>
        {shouldRenderChildren ? children : null}
      </Box>
      <FooterNew />
      {/* <Footer /> */}
    </ScrollToTopWrapper>
  );
};

export default PublicLayout;
